import { useId } from 'react';

export function MessengerIcon({ className }: { className?: string }) {
  const gradientId = useId();
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="0%"
          y1="0%"
          x2="0%"
          y2="100%"
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(189.16 12 12)"
        >
          <stop offset="6.95%" stopColor="#00B1FF" />
          <stop offset="94.81%" stopColor="#006BFF" />
        </linearGradient>
      </defs>
      <path
        d="M12 2C6.477 2 2 6.145 2 11.243c0 2.906 1.336 5.499 3.43 7.207V22l3.166-1.738c.846.233 1.743.359 2.673.359h.134c5.383-.046 9.783-4.162 9.783-9.239C21.186 6.145 17.523 2 12 2zm1.075 12.425l-2.5-2.5-4.875 2.5 5.375-5.5 2.5 2.5 4.875-2.5-5.375 5.5z"
        fill={`url(#${gradientId})`}
      />
    </svg>
  );
}
